import { render, staticRenderFns } from "./GameLabel.vue?vue&type=template&id=d33f542e&"
import script from "./GameLabel.vue?vue&type=script&lang=js&"
export * from "./GameLabel.vue?vue&type=script&lang=js&"
import style0 from "./GameLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports